import { Link } from "react-router-dom";
import TechHero from "../components/TechHero";
import useSEO from "../hooks/useSEO";
import { blogPosts } from "../data/blogPosts";

export default function Blog() {
  useSEO(
    "Engineering Insights | ZS NEXATECH",
    "Technical insights on scalable SaaS architecture, startup tech stack decisions, and AI integration for modern digital products.",
    "software engineering blog, SaaS architecture, startup tech stack, AI integration",
    "https://www.zsnexatech.com/blog"
  );

  return (
    <div className="space-y-10">
      <TechHero
        kicker="Engineering Insights"
        title="Practical product and engineering guidance"
        subtitle="Actionable insights for founders and teams building secure, scalable, high-performance digital products."
        ctaText="Book Free Consultation"
        ctaLink="/book-consultation"
      />

      <section className="space-y-6">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">Latest insights</h2>
          <p className="mt-2 text-gray-100">Strategy, architecture, and execution lessons from real delivery experience.</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <article
              key={post.slug}
              className="card rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-6 hover:shadow-2xl hover:scale-105 hover:bg-white/20 transition-all duration-300"
            >
              <p className="text-xs tracking-widest font-semibold text-red-200">{post.category}</p>
              <h3 className="mt-2 text-xl font-bold text-white">{post.title}</h3>
              <p className="mt-3 text-sm text-gray-100">{post.excerpt}</p>
              <div className="mt-4 flex items-center justify-between text-xs text-white/80">
                <span>{post.readTime}</span>
                <span>{new Date(post.publishedAt).toLocaleDateString()}</span>
              </div>
              <Link to={`/blog/${post.slug}`} className="btn-gold consultation-booking mt-5 w-full">
                Read article
              </Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
